import React from "react";
import DeactivateUserListData from "../../../components/userlistdata/deactivateuserlistdata";

const DeactivatedUsers = () => {
  return(
    <>
      <DeactivateUserListData/>
    </>
  );
};

export default DeactivatedUsers;
